/** Short intro for the handbook center highlight (only where layout does not already open with the same copy). */
export function getWelcomePackHandbookIntro(_topicId) {
  return null
}
